import React, { Fragment } from "react";
import FinancialChart from "../../assets/media/AdminRegistration/financial-profit.png";
import CoinsIcon from "../../assets/media/AdminRegistration/coins.png";
import ListSpacesIcon from "../../assets/media/AdminRegistration/list-spaces.png";
import LocalAdsIcon from "../../assets/media/AdminRegistration/local-ads.png";

export const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const adminTypeMapping = {
  marketplacelister: "Marketplace lister",
  contentcreator: "Content and marketing",
};

export const brandedBannerContent = [
  {
    title: (
      <Fragment>
        <span className="content-block--show-on-desktop">
          Listing un-utilised space
        </span>
        <span className="content-block--show-on-mobile">
          Make use <br /> of spaces
        </span>
      </Fragment>
    ),
    paragraph: (
      <Fragment>
        Do you have a space that can be used for advertising? This could be
        anything from an unused shop front, a wall with high exposure, a white
        van or sponsorship of sports team kits. Create exposure and send
        prospects offers.
      </Fragment>
    ),
    image: { src: ListSpacesIcon, alt: "listing un-utilised space" },
  },
  {
    title: (
      <Fragment>
        Local ads<span className="content-block--show-on-desktop">,</span>
        <br className="content-block--show-on-mobile" />{" "}
        <span className="content-block--show-on-mobile">{"and "}</span>
        local people
      </Fragment>
    ),
    paragraph: (
      <Fragment>
        Have an unusual space you're unsure how to utilise? Our local ad experts
        will help you to <b>maximally monetise</b> this opportunity. We&apos;ll
        then help you to find <b>suitable advertisers,</b> who are waiting to
        unlock reciprocal value.
      </Fragment>
    ),
    image: { src: LocalAdsIcon, alt: "local ads" },
  },
  {
    title: (
      <Fragment>
        Getting gold <br className="content-block--show-on-mobile" />
        out of stone
      </Fragment>
    ),
    paragraph: (
      <Fragment>
        Keep ad spaces occupied by using Eyeline to bring traffic and cash in
        quickly. Rather than sitting idle, vacant, and pushing up opportunity
        cost, we help you pick up the lost money pot, without you needing to do
        any heavy lifting.
      </Fragment>
    ),
    image: { src: CoinsIcon, alt: "coins" },
  },
  {
    title: (
      <Fragment>
        Boosting <br className="content-block--show-on-mobile" />
        return and reach
      </Fragment>
    ),
    paragraph: (
      <Fragment>
        Your new <b>slick, trustworthy, no-brainer</b> sales funnel helps you
        drive better conversion, commerciality and reviews. We put you in
        control of <b>sending offers</b> to interested parties and
        <b> expanding demand</b> with reach bumps.
      </Fragment>
    ),
    image: { src: FinancialChart, alt: "financial chart" },
  },
];



// WEBPACK FOOTER //
// ./src/screens/AdminRegistration/constants.js